import React from 'react';
import Divider from '@material-ui/core/Divider';
import { AdvancedSearch, AISearch } from 'common';
import { API_CLIENT_NAMES } from 'services/API';
import { FilterType } from 'UI/constants/defaults';

import { FILTER_CONFIG } from './Filters.constants';

export const FiltersList = ({ formValues, onFilterChange }) => {
  const renderFilter = filterConfig => {
    const {
      apiClient,
      endpoint,
      fieldName,
      formatSelectedItems,
      formatValue,
      getOptionLabel,
      getValue,
      groupBy,
      name,
      placeholder,
      preferencesEndpoint,
      preferencesFieldName,
      renderOption,
      title,
      type,
      typeahead,
      typeaheadLimit,
      typeaheadParams
    } = filterConfig;

    const filterValue = formValues?.[name]?.value;

    if (type === FilterType.AdvancedSearch) {
      return (
        <>
          <AdvancedSearch
            apiClient={apiClient ?? API_CLIENT_NAMES.Secondary}
            endpoint={endpoint}
            fieldName={fieldName}
            getOptionId={option => option.id ?? option.value ?? option}
            getOptionLabel={getOptionLabel || (option => option.value)}
            groupBy={groupBy}
            onSelectionChange={(fieldNameVal, selectedItems) => {
              onFilterChange(name, {
                fieldName: fieldNameVal,
                preferencesFieldName,
                value: formatSelectedItems ? formatSelectedItems(selectedItems) : selectedItems
              });
            }}
            placeholder={placeholder}
            preferencesEndpoint={preferencesEndpoint}
            renderOption={renderOption}
            selectedItems={filterValue || []}
            title={title}
            typeahead={typeahead}
            typeaheadLimit={typeaheadLimit}
            typeaheadParams={typeaheadParams ?? { limitKey: 'size' }}
          />
          <Divider />
        </>
      );
    }

    if (type === FilterType.Search) {
      return (
        <>
          <AISearch
            title={title}
            placeholder={placeholder}
            value={getValue ? getValue(filterValue) : filterValue}
            onChange={(nameVal, value) => {
              onFilterChange(nameVal, {
                fieldName,
                value: formatValue ? formatValue(value) : value
              });
            }}
            name={name}
          />
          <Divider />
        </>
      );
    }

    return null;
  };

  return (
    <>
      {FILTER_CONFIG.map(config => (
        <React.Fragment key={config.name}>{renderFilter(config)}</React.Fragment>
      ))}
    </>
  );
};
